"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type PostVersionRequest } from "@/generated/fastapi";
import { postVersion } from "../api/postVersion";
import { versioningKeys } from "../queries/keys";

export default function useCreateVersionMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: PostVersionRequest) =>
      postVersion(accessToken, request),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: versioningKeys.all }),
  });
}
